import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import jwtDecode from 'jwt-decode';
import React from 'react';
import { useContext } from 'react';
import useLogOutUser from 'Routes/Protected/MainPage/Components/MainMenuDrawer/Hooks/useLogOutUser';

const useCheckApiTokenExpiry = () => {
  const GlobalConstants = useContext(GlobalContext);
  const setIsTokeValid =
    useContext(GlobalContext)?.setIsTokeValid;
  const setDrawerOpen = GlobalConstants.setDrawerOpen;
  const { LogUserOut } = useLogOutUser(setDrawerOpen);
  let token = JSON.parse(localStorage.getItem('AuthToken'));
  let interval = React.useRef(null);
  const expireMsg = FindLangKey(
    'token-expire-alert-expired'
  );

  const checkHereForToken = () => {
    if (
      token !== false &&
      localStorage.getItem('AuthToken') !== null
    ) {
      if (jwtDecode(token).exp < Date.now() / 1000) {
        clearInterval(interval.current);

        // SwalAlert('error', expireMsg, false).then(() => {
        //   setIsTokeValid(false);
        //   LogUserOut();
        // });

        setIsTokeValid(false);
        LogUserOut();
      } else {
        setIsTokeValid(true);
      }
    } else {
      setIsTokeValid(false);
    }
  };

  React.useEffect(() => {
    checkHereForToken();
    // interval.current = setInterval(checkHereForToken, 1000);
    // return () => clearInterval(interval.current);
  }, [token, LogUserOut]);
};

export default useCheckApiTokenExpiry;
